import normal from './normal.png';
import fighting from './fighting.png';
import flying from './flying.png';
import poison from './poison.png';
import ground from './ground.png';
import rock from './rock.png';
import bug from './bug.png';
import ghost from './ghost.png';
import steel from './steel.png';
import fire from './fire.png';
import water from './water.png';
import grass from './grass.png';
import electric from './electric.png';
import psychic from './psychic.png';
import ice from './ice.png';
import dragon from './dragon.png';
import dark from './dark.png';
import fairy from './fairy.png';

const games = {
	normal: normal,
	fighting: fighting,
	flying: flying,
	poison: poison,
	ground: ground,
	rock: rock,
	bug: bug,
	ghost: ghost,
	steel: steel,
	fire: fire,
	water: water,
	grass: grass,
	electric: electric,
	psychic: psychic,
	ice: ice,
	dragon: dragon,
	dark: dark,
	fairy: fairy
};

export default games;